import { Col, Row } from "antd";
import React from "react";
import { CustomLabel } from "../../../Common/style";
import {
  AddInfoTable,
  CounterOfferTable,
  LoadingTable,
  PPMCTable,
  SpecialConditionTable,
  TeleUWTable,
} from "../../../Components/UI/TableComponent";
import { status_code_constant_data } from "../../../Constant";
import { PolicyDetails } from "../CommonData";
import { AcceptCodesList } from "./constant";
import "./style.css";

const getTrimmedLoweCase = (string) => {
  if(typeof string === "string"){
    return string ? string?.trim()?.toLowerCase() : string;
  }
}
export const statusCode_Info = (data, type) => {
  if (data.DecisionCode) {
    return scenerio_data(data.DecisionCode, type);
  } else if (data.InterimStatusCode) {
    return scenerio_data(data.InterimStatusCode, type);
  }
  return false;
};

const scenerio_data = (data, type) => {
  if (Array.isArray(type)) {
    const res = type.find((ei) => data.includes(ei));
    return !!res;
  }
  return data.includes(type) ? true : false;
};

const getTableData = (data, type) => {
  const newData = data.filter((ei) => statusCode_Info(ei, type));
  return newData;
};
const showCounterOfferTable = (data, type, Component, callback = null, isComment = false) => {
  const { customerComment, proposalDetails } = PolicyDetails()
  const isProposerLevelCounterOffer = proposalDetails?.DecisionCode?.includes(status_code_constant_data.CounterOffer)
  const StatusArray = data?.map((dataItem) => getStatusCode(dataItem));
  let filteredStatusArray = [];
  if (Array.isArray(type)) {
     filteredStatusArray =  StatusArray?.filter((sItem) => type?.some((ei) => getTrimmedLoweCase(sItem)?.includes(ei?.toLowerCase())));
  }
  else{
    filteredStatusArray = StatusArray?.filter((sItem) => getTrimmedLoweCase(sItem)?.includes(getTrimmedLoweCase(type)));
  }
  const isShowComment = (filteredStatusArray?.length > 0 || isProposerLevelCounterOffer) && isComment;
  const showTableByProposer = isProposerLevelCounterOffer && !(getTableData(data, type).length > 0) 
  return (
    <>
      {getTableData(data, type).length > 0 && (
        <Col span={24}>
          <Component
            data={getTableData(data, type)}
            type={type}
            callback={callback}
          />
        </Col>
      )}
      {showTableByProposer && (
        <Col span={24}>
        <Component
          data={data}
          type={type}
          callback={callback}
        />
      </Col>
      )}
      {(isShowComment) && (
        <>
          <Col xs={24} style={{ marginTop: "10px" }}>
            <CustomLabel font_size="14">{"Comments"}</CustomLabel>
            <CustomLabel
              font_size="14"
              font_weight="normal"
              style={{ marginTop: "10px" }}
            >
              {customerComment}
            </CustomLabel>
            <CustomLabel
              font_size="14"
              font_weight="normal"
              style={{ marginTop: "10px" }}
            >
              {proposalDetails?.ProposedChangeCounterOfferDescription}
            </CustomLabel>
          </Col>
        </>
      )}
    </>
  );
};
const showTable = (data, type, Component, callback = null, isComment = false, SpecialAdditionalData = null) => {
  const { customerComment } = PolicyDetails()
  const StatusArray = data?.map((dataItem) => getStatusCode(dataItem));
  let filteredStatusArray = [];
  if (Array.isArray(type)) {
     filteredStatusArray =  StatusArray?.filter((sItem) => type?.some((ei) => getTrimmedLoweCase(sItem)?.includes(ei?.toLowerCase())));
  }
  else{
    filteredStatusArray = StatusArray?.filter((sItem) => getTrimmedLoweCase(sItem)?.includes(getTrimmedLoweCase(type)));
  }
  const isShowComment = filteredStatusArray?.length > 0 && isComment;
  return (
    <>
      {getTableData(data, type).length > 0 && (
        <Col span={24}>
          <Component
            data={getTableData(data, type)}
            type={type}
            callback={callback}
          />
        </Col>
      )}
      {isShowComment && (
        <>
          <Col xs={24} style={{ marginTop: "10px" }}>
            <CustomLabel font_size="14">{"Comments"}</CustomLabel>
            <CustomLabel
              font_size="14"
              font_weight="normal"
              style={{ marginTop: "10px" }}
            >
              {SpecialAdditionalData?.isSpecial &&
              SpecialAdditionalData?.isParamPlanDescription
                ? "Please note, waiting period as mentioned above will be applicable in your policy for the disclosed condition. Apart from these, all other conditions will be included from Day 1 if you have not chosen the Pratiksha optional cover in the plan."
                : customerComment}
            </CustomLabel>
          </Col>
        </>
      )}
    </>
  );
};

const getStatusCode = (dataItem) => {
  if (dataItem?.DecisionCode) {
    return getTrimmedLoweCase(dataItem?.DecisionCode);
  } 
  else if (dataItem?.InterimStatusCode) {
    return getTrimmedLoweCase(dataItem?.InterimStatusCode);
  }
};
const StatusTable = ({ data, renderUploadDocsButton, renderAcceptOfferBlock, setBulletPoints, setStatusFlagDetails, isParamPlanDescription, proposalLevelCounterOffer }) => {
  const { PremiumUWloading, TotalUWLoading } = PolicyDetails().proposalDetails
  const SpecialAdditionalData = {
    isSpecial: true,
    isParamPlanDescription
  }
  //ACCEPT_COUNTER_OFFER
  const StatusArray = data?.map((dataItem) => getStatusCode(dataItem));
  const filteredStatusArray = StatusArray?.filter((sItem) => AcceptCodesList?.map((i) => getTrimmedLoweCase(i))?.includes(sItem));
  const isAcceptTypeCode = filteredStatusArray?.length > 0 || proposalLevelCounterOffer;
  const isLoadingType = filteredStatusArray?.some((fItem) => fItem?.includes("loading"));
  //ACCEPT_COUNTER_OFFER
  const bullet_points_data = [
    ...(getTableData(data, status_code_constant_data.Add_info).length > 0
      ? ["Additional information"]
      : []),
    ...(getTableData(data, status_code_constant_data.PPMC).length > 0
      ? ["Pre-Policy Medical Check-up"]
      : []),
    ...(getTableData(data, status_code_constant_data.SpecialCondition).length >
    0
      ? ["Special Condition"]
      : []),
    ...(getTableData(data, status_code_constant_data.Loading).length > 0
      ? ["Loading"]
      : []),
    ...(getTableData(data, status_code_constant_data.CounterOffer).length > 0 || proposalLevelCounterOffer
      ? ["CounterOffer"]
      : []),
    ...(getTableData(data, status_code_constant_data.CoPayment).length > 0
      ? ["Accept with Co payment"]
      : []),
    ...(getTableData(data, status_code_constant_data.Deductible).length > 0
      ? ["Deductible"]
      : []),
    ...(getTableData(data, status_code_constant_data.TeleUW).length > 0
      ? ["Tele underwriting"]
      : []),
  ];
  if (bullet_points_data?.length === 0) {
    return null;
  }
  else {
    setBulletPoints(bullet_points_data)
  }
  return (
    <div className="status-table">
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <CustomLabel font_weight="normal">
            We would like to inform you that we have successfully completed the
            evaluation of your insurance proposal{" "}
          </CustomLabel>{" "}
        </Col>
        <Col span={24}>
          <CustomLabel font_weight="normal">
            Basis the underwriting guidelines of the company, your insurance
            proposal will be processed subject to the acceptance of the
            following revised terms.{" "}
          </CustomLabel>{" "}
        </Col>
        {bullet_points_data.length > 0 && (
          <Col span={24}>
            {bullet_points_data.map((ei) => (
              <li key={ei}>
                <label style={{ display: "inline", fontWeight: "normal" }}>
                  {ei}
                </label>
              </li>
            ))}
          </Col>
        )}
        {showTable(data, status_code_constant_data.Add_info, AddInfoTable)}
        {renderUploadDocsButton()}
        {showTable(data, status_code_constant_data.PPMC, PPMCTable)}
        {showTable(
          data,
          status_code_constant_data.SpecialCondition,
          SpecialConditionTable,
          setStatusFlagDetails,
          true,
          SpecialAdditionalData
        )}
        {getTableData(data, status_code_constant_data.Loading).length > 0 && (
          <Col span={24}>
            <LoadingTable
              data={getTableData(data, status_code_constant_data.Loading)}
              PremiumUWloading={PremiumUWloading}
              TotalUWLoading={TotalUWLoading}
              callback={setStatusFlagDetails}
            />
          </Col>
        )}
        {showCounterOfferTable(
          data,
          status_code_constant_data.CounterOffer,
          CounterOfferTable,
          setStatusFlagDetails,
          true
        )}
        {showTable(
          data,
          status_code_constant_data.CoPayment,
          CounterOfferTable,
          setStatusFlagDetails,
          true
        )}
        {showTable(
          data,
          status_code_constant_data.Deductible,
          CounterOfferTable,
          setStatusFlagDetails,
          true
        )}
        {isAcceptTypeCode && renderAcceptOfferBlock(isLoadingType)}
        {showTable(data, status_code_constant_data.TeleUW, TeleUWTable)}
      </Row>
    </div>
  );
};

export default StatusTable;
